import { render, staticRenderFns } from "./BrImageSideZoom.vue?vue&type=template&id=1f5d934f&scoped=true&"
import script from "./BrImageSideZoom.vue?vue&type=script&lang=js&"
export * from "./BrImageSideZoom.vue?vue&type=script&lang=js&"
import style0 from "./BrImageSideZoom.vue?vue&type=style&index=0&id=1f5d934f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f5d934f",
  null
  
)

export default component.exports